import React from "react";

import Topbar from "../components/topbar";
import { useMediaQuery, useTheme, Box, Typography } from "@mui/material";
import Dropdown from "../components/ui/dropdown";
import ProfitLossTable, { ProfitLossRow } from "../components/profit-loss-table";

const ProfitLoss: React.FC = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    React.useEffect(() => {
        document.title = "FineAnts | Profit & Loss";
    }, []);

    const plData: ProfitLossRow[] = [
        { label: 'INCOME', isSection: true, fy2025: 0, fy2026: 0 },
        { label: 'Bank – Current', fy2025: 1000, fy2026: 1580 },
        { label: 'Petty Cash', fy2025: 2000, fy2026: 2750 },
        { label: 'Professional Services Income', fy2025: 3000, fy2026: 3120 },
        { label: 'Consulting Fees', fy2025: 4000, fy2026: 4850 },
        { label: 'Other Revenue', fy2025: 5000, fy2026: 5460 },
        { label: 'Interest Income', fy2025: 6000, fy2026: 6740 },
        { label: 'Retained Earnings', fy2025: 7000, fy2026: 7950 },
        { label: 'Uncategorized', fy2025: 8000, fy2026: 7110 },
        
        { label: 'EXPENSE', isSection: true, fy2025: 0, fy2026: 0 },
        { label: 'Salaries & Wages', fy2025: 600, fy2026: 710 },
        { label: 'Superannuation Expense', fy2025: 650, fy2026: 370 },
        { label: 'Subcontractor Costs', fy2025: 700, fy2026: 760 },
        { label: 'Telephone & Internet', fy2025: 750, fy2026: 800 },
        { label: 'Travel & Accommodation', fy2025: 800, fy2026: 890 },
        { label: 'Professional Fees (Legal, Accounting)', fy2025: 850, fy2026: 840 },
        { label: 'Advertising & Marketing', fy2025: 900, fy2026: 960 },
        { label: 'Office Supplies & Stationery', fy2025: 950, fy2026: 970 },
        
        { label: 'Total Income', isTotal: true, isBold: true, fy2025: 36000, fy2026: 39560 },
        { label: 'Total Loss', isTotal: true, isBold: true, fy2025: 6200, fy2026: 6300 },
        { label: 'Net Income (Loss)', isTotal: true, isBold: true, fy2025: 29800, fy2026: 33260 },
    ];

    return (
        <div style={{ width: '100%' }}>
            <Topbar 
                title="Profit & Loss"
                isMobile={isMobile}
            />
            <Box sx={{ padding: isMobile ? 0.5 : 1 }}>
                <ProfitLossTable data={plData} />
            </Box>
        </div>
    );
};

export default ProfitLoss;